export default "__VITE_ASSET__B$WbBUfn__"